module.exports = __webpack_public_path__ + "img/mobile.b4ff6fb6.png";